import { successNotifyService, failureNotifyService } from "@/services/errors.service.js";
import { isArray } from "core-js/fn/array";
import { isInteger } from "core-js/fn/number";
import { isBoolean } from "lodash";

export function checkInputFieldService(localData, action) {
    let cfObj = {};

    //////////////////////////////////////
    /// Skills
    //////////////////////////////////////

    if (action === 'saveProfession') {
        cfObj.fieldName = 'profession';
        cfObj.fieldValueIsNull = false; // this field can be null
        cfObj.collectionName = 'users';
        cfObj.vuexServiceName = 'users';
        return cfObj;

    } else if (action === 'saveSkills') {
        cfObj.fieldName = 'skills';
        cfObj.fieldValueIsNull = false; // this field can be null
        cfObj.collectionName = 'skills';
        cfObj.vuexServiceName = 'editor';
        return cfObj;

    } else if (action === 'saveLanguages') {
        cfObj.fieldName = 'languages';
        cfObj.fieldValueIsNull = false; // this field can be null
        cfObj.collectionName = 'languages';
        cfObj.vuexServiceName = 'editor';
        return cfObj;

    } else if (action === 'saveHobbies') {
        cfObj.fieldName = 'hobbies';
        cfObj.fieldValueIsNull = false; // this field can be null
        cfObj.collectionName = 'hobbies';
        cfObj.vuexServiceName = 'editor';
        return cfObj;

    } else {
        cfObj.fieldName = null;
        cfObj.fieldValueIsNull = true;
        cfObj.collectionName = null;
        cfObj.vuexServiceName = null;
        return cfObj;
    }

}

export function saveInputFieldService(payload) {

    const isUserLoggedIn = payload.isUserLoggedIn;
    const action = payload.action;
    const currentThis = payload.currentThis;
    const localData = payload.localData;
    const userId = payload.userId;
    const localExtraCurricularData = payload.localExtraCurricularData;

    const cfObj = checkInputFieldService(localData, action);
    
    // // console.log(cfObj, payload);

    if (!isUserLoggedIn || cfObj.fieldValueIsNull) {
        return;
    }

    currentThis.$store.commit("editor/TOGGLE_SAVE_IN_PROGRESS", true);

    // // console.log("executing...", localData);

    const fieldName = cfObj.fieldName;
    const vuexServiceName = cfObj.vuexServiceName;

    const dataObj = {};

    if(action === "saveProfession") {
        dataObj["_id"] = userId;
        dataObj[`${fieldName}`] = localData[`${fieldName}`].trim();
    } else {
        dataObj["_id"] = localExtraCurricularData._id;
        dataObj[`${fieldName}`] = localExtraCurricularData[`${fieldName}`];
    }
    
    dataObj['collectionName'] = cfObj.collectionName;

    /*if (localData[`${fieldName}`]) { // If field value is not null
        
        if(isInteger(localData[`${fieldName}`])) {
            dataObj[`${fieldName}`] = Number(localData[`${fieldName}`].toString().trim());
        } if(isBoolean(localData[`${fieldName}`])) {
            dataObj[`${fieldName}`] = Boolean(localData[`${fieldName}`].toString().trim());
        } if(isArray(localData[`${fieldName}`])) {
            dataObj[`${fieldName}`] = localData[`${fieldName}`];
        } else {
            dataObj[`${fieldName}`] = localData[`${fieldName}`].trim();
        }

    } else dataObj[`${fieldName}`] = null; // If field value is null*/

    currentThis.$store
        .dispatch(`${vuexServiceName}/${action}`, dataObj)
        .then((res) => {
            currentThis.$store.commit(
                "editor/TOGGLE_SAVE_IN_PROGRESS",
                false
            );
            //// console.log(res);
        })
        .catch((err) => {
            throw err;
        });
}